export default __webpack_public_path__ + "static/media/GreenMarker.92285f32.png";